import { render, staticRenderFns } from "./BrandsDiscounts.vue?vue&type=template&id=f6f33de2"
import script from "./BrandsDiscounts.vue?vue&type=script&lang=js"
export * from "./BrandsDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports